import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  list: [],
  locations: [],
  nextTravelID: undefined,
  total_list: 0,
  pagination: { num_page: 0, num_items: 20 },
  current_filters: {}
};

// getters
const getters = {
  getList: (state, getters, rootState) => type => {
    var aTravels = [];
    for (var i in state.list) {
      if (state.list[i].visible) aTravels.push(state.list[i]);
    }
    return aTravels;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  get_by_id: (state, getters, rootState) => id => {
    if (typeof state.list[id] !== "undefined") return state.list[id];
    return false;
  },

  get_location_by_id: (state, getters, rootState) => id => {
    if (typeof state.locations[id] !== "undefined") return state.locations[id];
    return false;
  },

  getNextTravelID: (state, getters, rootState) => id => {
    if (typeof state.nextTravelID !== "undefined") return state.nextTravelID;
    return false;
  },

  getLocations: (state, getters, rootState) => () => {
    if (typeof state.locations !== "undefined") return state.locations;
    return false;
  },

  getListNoFiltered: (state, getters, rootState) => () => {
    var aTravels = [];
    for (var i in state.list) {
      aTravels.push(state.list[i]);
    }
    return aTravels;
  },

  getTravelsType: (state, getters, rootState, rootGetters) => () => {
    var aData = {};
    var travelTypes = rootGetters["getTravelTypes"]();
    (Array.isArray(travelTypes) ? travelTypes : Object.values(travelTypes)).forEach(type => {
      aData[type.id + 't'] = { name: type.name, id: +type.id }
    })
    return aData;
  }
};

// actions
const actions = {
  loadList({ dispatch, commit, state, rootState, rootGetters }, params) {
    if (parseInt(rootGetters["events/getCurrentEvent"]().is_campus) != 1) {
      var paramsClub = {
        page_options: { num_page: -1, num_items: -1 },
        filters: {}
      };
      if (params && params.event) paramsClub.event = params.event;
      dispatch("clubs/loadList", paramsClub, { root: true }).then(function() {
        dispatch(
          "teams/loadList",
          {
            event: params.event,
            page_options: { num_page: -1, num_items: -1 },
            filters: { status: "6" }
          },
          { root: true }
        ).then(function() {
          dispatch(
            "travels/loadLocations",
            { page_options: { num_page: -1, num_items: -1 } },
            { root: true }
          ).then(function() {
            var path =
              "travel" +
              (typeof params !== "undefined" &&
              typeof params.event !== "undefined"
                ? "/event/" + params.event
                : "");
            var page_options =
              params && params.page_options
                ? params.page_options
                : state.pagination;
            var filters =
              params && params.filters ? params.filters : state.current_filters;
            var oParams = Object.assign(filters ? filters : {}, page_options);

            return api.post(path, oParams).then(function(response) {
              if (response.status) {
                var data = response.data.data;
                for (var i in data) {
                  data[i].visible = true;
                  data[i].bus_private =
                    parseInt(data[i].bus_private) == "1" ? "true" : "false";
                  for (var k in data[i].people) {
                    var entity = data[i].people[k];
                    if (entity.entity_type == "2") {
                      var team = rootState.teams.list[k];
                      if (team) {
                        data[i].people[k].gestor_id = team.club
                          ? team.club.gestor_id
                          : NULL;
                        data[i].people[k].name = team.name;
                        data[i].people[k].category = team.category.max_age;
                        data[i].people[k].shield = team.club
                          ? team.club.shield
                          : "";
                      } else {
                        data[i].visible = false;
                      }
                    }
                  }
                }
                commit("setList", { data: data, total: response.data.total });
                return commit("setPagination", page_options);
              }
            });
          });
        });
      });
    } else {
      dispatch(
        "persons/loadList",
        {
          page_options: { num_page: -1, num_items: -1 },
          filters: {},
          page: "participants"
        },
        { root: true }
      ).then(function() {
        dispatch(
          "travels/loadLocations",
          { page_options: { num_page: -1, num_items: -1 } },
          { root: true }
        ).then(function() {
          var path =
            "travel" +
            (typeof params !== "undefined" &&
            typeof params.event !== "undefined"
              ? "/event/" + params.event
              : "");
          var page_options =
            params && params.page_options
              ? params.page_options
              : state.pagination;
          var filters =
            params && params.filters ? params.filters : state.current_filters;
          var oParams = Object.assign(filters ? filters : {}, page_options);

          return api.post(path, oParams).then(function(response) {
            if (response.status) {
              var data = response.data.data;
              for (var i in data) {
                data[i].visible = true;
                for (var k in data[i].people) {
                  var entity = data[i].people[k];
                  if (entity.entity_type == "3") {
                    var people = rootState.persons.list[k];
                    //   data[i].people[k].gestor_id = people.club.gestor_id;
                    data[i].people[k].name = people.name + " " + people.surname;
                    //   data[i].people[k].category = people.category.max_age;
                    //   data[i].people[k].shield = people.club.shield;
                  }
                }
              }
              commit("setList", { data: data, total: response.data.total });
              return commit("setPagination", page_options);
            }
          });
        });
      });
    }
  },

  loadLocations({ dispatch, commit, rootState }, params) {
    var oParams = { page_options: { num_page: -1, num_items: -1 } };
    if (params && params.event) oParams.event = params.event;

    return dispatch("hotels/loadList", oParams, { root: true }).then(
      function() {
        return dispatch("facilitys/loadList", oParams, { root: true }).then(
          function() {
            return api
              .get("travel/nextid/" + oParams.event)
              .then(function(response) {
                if (response.status) {
                  commit("setNextTravelID", response.data);
                  return api.get("travel/locations").then(function(response) {
                    if (response.status) {
                      return commit("setLocations", response.data);
                    }
                  });
                }
              });
          }
        );
      }
    );
  },

  load_by_id({ commit }, params) {
    var path = "travel/" + params.id;
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return commit("addTravel", data);
      }
    });
  },

  upload(context, data) {
    var travel = { ...data.data };
    travel.event = data.event;
    var params = data.params;
    var path =
      typeof travel.id !== "undefined"
        ? "travel/" + travel.id + "/update"
        : "travel/add";
    return api.post(path, travel).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;
        context.commit("addTravel", data);
        return data.id;
      }
    });
  },

  remove(context, id) {
    return api.post("travel/" + id + "/remove", {}).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        context.commit("removeTravel", id);
      }
    });
  },

  remove_relation(context, params) {
    return api
      .post("travel/" + params.travel_id + "/remove_relation", {
        rel_id: params.rel,
        type: params.type
      })
      .then(function(response) {
        if (response.status) {
          return true;
        }
        return false;
      });
  },

  create_bifurcation(context, params) {
    return api
      .post("travel/" + params.travel_id + "/create_bifurcation", {
        rel_id: params.rel,
        type: params.type
      })
      .then(function(response) {
        if (response.status) {
          return response.data.id;
        }
        return false;
      });
  },

  loadTeamTravels: ({ commit }, params) => {
    return api.get("travel/team/" + params.team_id).then(function(response) {
      var data = response.data;
      for (var i in data) {
        data[i].visible = true;
      }
      return commit("setTravel", response.data);
    });
  },

  loadParticipantTravels: ({ commit }, params) => {
    return api
      .get(
        "travel/participant/" +
          params.participant_id +
          "/event/" +
          params.event_id
      )
      .then(function(response) {
        var data = response.data;
        for (var i in data) {
          data[i].visible = true;
        }
        return commit("setTravel", response.data);
      });
  },

  loadTravelInfo({ dispatch, commit, rootState }, params) {
    return api.get("travel/locations").then(function(response) {
      if (response.status) {
        return commit("setLocations", response.data);
      }
    });
  }
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  setLocations(state, data) {
    state.locations = data;
  },

  addTravel(state, travel) {
    var list = { ...state.list };
    list[travel.id] = travel;

    state.list = list;
  },

  removeTravel(state, id) {
    var list = { ...state.list };
    delete list[id];

    state.list = list;
  },

  setTravel(state, value) {
    state.list = value;
  },

  setNextTravelID(state, nextID) {
    state.nextTravelID = nextID;
  },

  // addNote( state, { id, note } ) {
  //     var list = { ...state.list };
  //     list[ id ].notes[ note.id ] = note ;

  //     state.list = list;
  // },

  // removeNote( state, { id, note } ){
  //     var list = { ...state.list };
  //     delete list[ id ].notes[ note ];

  //     state.list = list;
  // },

  applyFilters(state, filters) {
    state.current_filters = filters;
    // var list = {...state.list};
    // if( !filters ){
    //     for( var i in list ){
    //         list[ i ].visible = true;
    //     }
    // }
    // else {
    //     for( var i in list ){
    //         list[ i ].visible = false;
    //     }
    //     for( var i in list ){
    //         var item = list[ i ];
    //         var bFound = true;
    //         var bFoundTeam = true;
    //         var bFoundGestor = true;
    //         console.log( filters);
    //         for( var k in filters ){

    //             console.log("FILTER - " + k + " - VAL: " + filters[k] )
    //             if( k == 'gestor_id' ){
    //                 console.log( "found gestor" )
    //                 bFoundGestor = false
    //                 for( var j in item.people ){
    //                     var entity = item.people[j];
    //                     if( entity.entity_type == "2" && entity.gestor_id == filters[k] ) bFoundGestor = true;
    //                 }
    //             }
    //             else if( k == 'team' ){
    //                 console.log( "found team" );
    //                 bFoundTeam = false;
    //                 for( var j in item.people ){
    //                     var entity = item.people[j];
    //                     if( entity.entity_type == "2" && j == filters[k] ) bFoundTeam = true;
    //                 }
    //             }
    //             else{
    //                 if ( item[k]== null ) {
    //                     bFound = false;
    //                     continue;
    //                 }

    //                 var item_value = ( typeof item[k] == 'object' )? item[k].id : item[k];
    //                 // console.log( "ITEM: " + item[k] + " - FILTER: " + filters[k] );
    //                 if ( typeof filters[k] === 'string' && filters[k]!= "" && item.hasOwnProperty( k ) && filters[k].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() != item_value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() ) {
    //                     bFound = false;
    //                 }
    //                 else if( typeof filters[k] != 'string' && item.hasOwnProperty( k ) && filters[k] != item_value ) {
    //                     bFound = false;
    //                 }
    //             }
    //         }

    //         list[ i ].visible = bFoundTeam && bFoundGestor && bFound;

    //     }
    // }

    // state.list = list;
  },
  setPagination(state, value) {
    state.pagination = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
